
/* eslint-disable */
import i18n from '@/plugins/i18n';

export const statusContratacao = [
  {
    text: i18n.t('app.contratacoes.filter.form.status.open'),
    value: 'ABERTA',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.closed'),
    value: 'FECHADA',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.manuallyClosed'),
    value: 'FECHADA_MANUALMENTE',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.closedByTransfer'),
    value: 'FECHADA_POR_REPASSE',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.overdue'),
    value: 'VENCIDA',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.renegotiation'),
    value: 'EM_RENEGOCIACAO',
  },
  {
    text: i18n.t('app.contratacoes.filter.form.status.manuallyInvalidate'),
    value: 'INVALIDADA_MANUALMENTE',
  },
];
